import m from './module';
import Field from '../model/Field';
import Form from '../model/Form';
import {
  getProvisionalIdentifierForType,
  mapObjectsByKey,
} from '../util';
import { createError } from '../error';

const path = '/recap_field';
const type = 'Field';

const fieldOptionMultiLanguageFields = ['name'];

class FieldService {
  constructor(
    $q,
    FieldTypeService,
    APIService,
    LanguageService,
    ValidationTypeService,
    DataSyncService
  ) {
    "ngInject";
    this.$q = $q;
    this.APIService = APIService;
    this.LanguageService = LanguageService;
    this.DataSyncService = DataSyncService;
    this.FieldTypeService = FieldTypeService;
    this.ValidationTypeService = ValidationTypeService;
    this._fieldMapPromise = null;
    this._getAllPromise = null;
  }

  forceGetAll(config = null) {
    config = config || { force: true };
    this.DataSyncService.clearPromisesForMultipleObjectsOfType(type);
    return this.getAll(config);
  }

  getAll(config = null) {
    return this.DataSyncService.getMultipleObjects(type, path, data => this.create(data), config);
  }

  getById(id, config = null) {
    return this.DataSyncService.getObjectByIdFromMultiple(type, path, id, data => this.create(data), config);
  }

  filterOptions(field, options) {
    let endOptions = options;
    if (field.filteredOptions.length) {
      const filteredIds = fieldfilteredOptions.map(option => option.id)
      endOptions = endOptions.filter(option => filteredIds.includes(option.id))
    }
    return endOptions;
  }

  create(data, config = null) {
    data = data || {};
    data.id = data.id || getProvisionalIdentifierForType('field');

    // Ensure all field options have populated multi-language data
    if (!data.options) {
      data.options = {};
    }

    // const populatedOptions = Object.values(data.options).map(optionData => {
    //   return this.LanguageService.populateMultiLanguageFields(optionData, )
    // })

    // Options are actually a map of option ID => option data
    let multiLanguageOptions = {};
    Object.keys(data.options).forEach(optionId => {
      const optionData = data.options[optionId];
      multiLanguageOptions[optionId] = this.LanguageService.populateMultiLanguageFields(optionData, fieldOptionMultiLanguageFields);
    });

    data.options = multiLanguageOptions;

    // data.options = new Map(
    //   Object.keys(data.options).map(optionId => {
    //     const optionData = data.options[optionId];
    //     const populatedData = this.LanguageService.populateMultiLanguageFields(optionData, fieldOptionMultiLanguageFields);
    //     return [optionId, populatedData];
    //   })
    // );

    let promise = this.$q.when(data);
    if (data.type) {
      // Populate data.fieldType
      promise = promise
        .then(() => this.FieldTypeService.getById(data.type, config))
        .then(fieldType => data.fieldType = fieldType)
        .then(() => this._getEnabledValidatonsByType(data.fieldType.defined_as))
        .then((enabledValidationTypes) => {
              data.enabledValidationTypes=enabledValidationTypes;
              data.nonTargetEnabledValidationTypes = enabledValidationTypes.filter(type => !type.target);
              data.hasEnabledValidationTypes = data.enabledValidationTypes.length;
        });
    }

    return promise.then(() => new Field(data));
  }

  _getFieldMapPromise() {
    return this.getAll()
      .then(allObjects => mapObjectsByKey(allObjects, 'id'));
  }

    _getEnabledValidatonsByType(type) {
    return this.ValidationTypeService.getAll()
      .then(allValidationTypes => {
        return this.$q.when(this.ValidationTypeService.enabledKeysForType(type))
        .then((enabledValidatonKeys) => {
          let validationTypes = allValidationTypes.filter((vtype) => {
            return enabledValidatonKeys.includes(vtype.key);
          });
          return validationTypes;
        })

      })
      .catch(err => {
        this.LogService.error("error loading validation types:", err);
        return this.$q.reject(err);
      });
  }
}

export default FieldService;

m.service('FieldService', FieldService);
